import { formatBigMoney, formatMoney, formatPercentage } from '../../../packages/utils/numberFormatters'
import { AXIS_OPTIONS_LABELS, AxisPropOption } from '../ScatterPlot'

export const formatValue = (
    item: Partial<Record<AxisPropOption, number | null>>,
    prop: AxisPropOption,
    { locale, short = true }: { locale: string; short?: boolean },
): string => {
    if (item[prop] === null || item[prop] === undefined) return ''
    if (AXIS_OPTIONS_LABELS[prop].type === 'percent') {
        return formatPercentage(item[prop], { decimals: short ? 0 : undefined, locale })
    }

    if (AXIS_OPTIONS_LABELS[prop].type === 'currency') {
        if (short) return formatBigMoney(item[prop], { locale })
        return formatMoney(item[prop], { locale })
    }

    return item[prop].toString()
}
